import reduxModule from "./redux";
import { useAdvertiser } from "./hook";

export { useAdvertiser };

export default reduxModule;
